import { IAnalyticsEvent } from '@verv-inc/js-toolkit/core-analytics';
import { getInternalProductIdFromName } from '../../scripts/getInternalProductIdFromName';
import getCurrencySymbol from '../../../utils/scripts/getCurrencySymbol';
import getProductDuration from '../../../utils/scripts/getProductDuration';
import getCurrencyValue from '../../scripts/getCurrencyValue';
import { eLTVChecker, eLTVLocalChecker } from '../../scripts/eLTVChecker';
import { determinePaymentVersion } from '../../scripts/paymentVersion';
import { getParameterFromURL } from '../../scripts/getParameterFromUrl';
import { PAYMENT_TARIFF } from '../../../types/tariffs';

const QuizFunnelEventName = 'quiz_funnel';
const currencySymbol = getCurrencySymbol();

interface GTMQuizFunnelEventTryPaidParameters {
  paymentType: string;
  trialPrice: string;
  productName: string;
  email?: string;
  eventId?: string;
}

export const GTMQuizFunnelEvent = {
  tryPaid: (parameters: GTMQuizFunnelEventTryPaidParameters): IAnalyticsEvent => {
    const offerType = window.showSpecialOffer ? 'special_offer' : 'main_offer';
    return {
      name: QuizFunnelEventName,
      info: {
        'quiz_action': 'payment_intention',
        'payment_system': parameters.paymentType,
        'trial_price': `${currencySymbol}${parameters.trialPrice}`,
        'product_name': parameters.productName,
        'product_name_tt': getInternalProductIdFromName(parameters.productName),
        'section': window.clickedPlanBlock,
        'product_duration': getProductDuration(parameters.productName),
        'offer_type': offerType,
        'currency': getCurrencyValue(),
        'payment_type': determinePaymentVersion() || 'unknown',
      }
    };
  },
  paymentSuccessful: (parameters: GTMQuizFunnelEventTryPaidParameters): IAnalyticsEvent => {
    const offerType = window.showSpecialOffer ? 'special_offer' : 'main_offer';
    const priceString = parameters?.trialPrice || ''; // Пример строки
    const numericValue = parseFloat(priceString.replace(/[^\d.-]/g, ''));
    const isWinbackSinglePlanCheckout = getParameterFromURL('singlePlanCheckout') !== null
      && getParameterFromURL('tariff') === PAYMENT_TARIFF.WINBACK_V1;
    const fromValue = getParameterFromURL('emailPaymentFail') !== null
      ? 'email_paymentFail'
      : getParameterFromURL('emailSubsExpiration') !== null
        ? 'email_subsExpiration'
        : isWinbackSinglePlanCheckout
          ? 'account'
          : null;
    return {
      name: QuizFunnelEventName,
      info: {
        'quiz_action': isWinbackSinglePlanCheckout ? 'payment_successful_winback' : 'payment_successful',
        'payment_system': parameters.paymentType,
        'value': `${currencySymbol}${parameters.trialPrice}`,
        'product_name': parameters.productName,
        'email': parameters.email,
        'complete_payment_value': numericValue,
        'product_name_tt': getInternalProductIdFromName(parameters.productName),
        'section': window.clickedPlanBlock,
        'product_duration': getProductDuration(parameters.productName),
        'offer_type': offerType,
        'currency': getCurrencyValue(),
        'payment_type': determinePaymentVersion() || '',
        'eLTV': eLTVChecker(getInternalProductIdFromName(parameters.productName)),
        'eLTV_local_value': eLTVLocalChecker(getInternalProductIdFromName(parameters.productName)),
        ...(fromValue ? { 'from': fromValue } : {}),
      }
    };
  },
  completePayment: (parameters: GTMQuizFunnelEventTryPaidParameters): IAnalyticsEvent => {
    const priceString = parameters?.trialPrice || '';
    const numericValue = parseFloat(priceString.replace(/[^\d.-]/g, ''));
    return {
      name: QuizFunnelEventName,
      info: {
        'quiz_action': 'complete_payment',
        'payment_system': parameters.paymentType,
        'value': `${currencySymbol}${parameters.trialPrice}`,
        'product_name': parameters.productName,
        'email': parameters.email,
        'complete_payment_value': numericValue,
        'product_name_tt': getInternalProductIdFromName(parameters.productName),
        'eventId': parameters.eventId,
        'currency': getCurrencyValue(),
      }
    };
  },
};